import { RteBlock } from '@components';
import { Alert } from '@mui/material';

export type AuthSuccessMessageProps = {
  message?: string;
};

export const AuthSuccessMessage = ({ message }: AuthSuccessMessageProps) => (
  <Alert severity='success'>
    <RteBlock text={message} />
  </Alert>
);
